module.exports = __webpack_public_path__ + "media/YEAH_Scribble_Kopf_Olli_480x480.b8bdd5d3.mp4";